export const useFormVisibilityHandler = () => {

    const verifyCondition = (conditiongroup, watch) => {
        let visible = true;
        let innerConditions = [];
        Array.isArray(conditiongroup.visibilitycondition) && conditiongroup.visibilitycondition.map((rule, k) => {
            if (Array.isArray(rule)) {
                innerConditions.push(verifyInnerRule(rule, watch))
            } else {
                innerConditions.push(rule)
            }
        })

        //console.info('innerConditions', innerConditions);
        // if (conditiongroup.type == 'sectiontitle' && (conditiongroup.visibilitycondition ?? []).length > 0) {
        //     console.info('qui verifyCondition', conditiongroup, innerConditions);
        // }

        // le condizioni possono essere 
        // a) una sola condizione valutata autonomamente
        // b) tre condizioni con la seconda una stringa 'and'/'or', risolte nei due if dedicati
        // c) N > 1 condizioni, tutte array, risolte in AND
        if (innerConditions.length == 1) {
            visible = innerConditions[0];
        } else if (innerConditions.length == 3 && innerConditions[1] == 'and') {
            //console.debug('verifyCondition 3 innerConditions', conditiongroup.name, conditiongroup.visibilitycondition, innerConditions);
            visible = innerConditions[0] && innerConditions[2];
        } else if (innerConditions.length == 3 && innerConditions[1] == 'or') {
            visible = innerConditions[0] || innerConditions[2];
        } else if (innerConditions.length > 1) {
            // caso con più condizioni, risolte in AND
            visible = innerConditions.every(element => element === true)
        }

        return visible;
    }

    const verifyInnerRule = (rule, watch) => {
        let visible = true;
        if (rule[2] == 'null') rule[2] = null
        const currentValue = watch(rule[0]) ?? null;

        switch (rule[1]) {
            case '=':
                if (currentValue != rule[2]) {
                    visible = false;
                }
                break;
            case '!=':
                if (currentValue == rule[2]) {
                    visible = false;
                }
                break;
            case 'in':
                if (!rule[2].includes(currentValue)) {
                    visible = false;
                }
                break;
            case 'nin':
                if (rule[2].includes(currentValue)) {
                    visible = false;
                }
                break;
            case 'countEquals':
                if (currentValue.length != parseInt(rule[2])) {
                    visible = false;
                }
                break;
            case 'countLess':
                if (currentValue.length < parseInt(rule[2])) {
                    visible = false;
                }
                break;
            case 'countMore':
                if (currentValue.length > parseInt(rule[2])) {
                    visible = false;
                }
                break;
        }

        //console.debug('verifyInnerRule rule', rule, rule[0], currentValue, (visible ? 'visible' : 'non visible'));
        return visible;
    }
    return {
        verifyCondition
    }
}